module.exports = __webpack_public_path__ + "static/media/show.731a8100.svg";